import { IMeasurementArea } from "models/MeasurementAreaModel";
import { BaseService } from "./base.service";

class MeasurementAreaServiceInternal extends BaseService {
	getMeasurementAreaList = async (): Promise<IMeasurementArea[]> =>
		this.callApi<IMeasurementArea[]>(`MeasurementArea/GetAll`, "GET");
}

export const MeasurementAreaService = new MeasurementAreaServiceInternal();
